import React from "react";
import { observer, inject } from "mobx-react";
import CollapseFiltersContainer from "Containers/CollapseFiltersContainer";
import { SelectField } from "ComponentsUI/Selectfield";
import OrientationChanger from "ComponentsUI/OrientationChanger";
import { SortPanel } from "ComponentsUI/Sort";
import { FiltersLayout, FiltersItem } from "ComponentsUI/Filters";
import Routes from "Configs/routes";
import { withRouter } from "react-router-dom";
import FiltersLoadParams from "HOC/FiltersLoadParams";
import { generateUrl } from "Services/withDefaultParams";
import queryString from "query-string";

@withRouter
@inject("ApplicationModel")
@observer
export default class Filters extends FiltersLoadParams {
	constructor(props) {
		super(props);
		let text = props.ApplicationModel.text;
		let params = queryString.parse(props.location.search);
		this.state = {
			sort: [
				{
					id: 1,
					key: "",
					name: text.SORT_BY_POP_1,
					down: true,
				},
				{
					id: 2,
					key: "name",
					name: text.SORT_BY_NAME_1,
					down: true,
				},
				{
					id: 3,
					key: "-name",
					name: text.SORT_BY_NAME_2,
					up: true,
				},
				// {
				//     id: 4,
				//     key: "-info.cnt_reviews",
				//     name: text.SORT_BY_REVIEWS_1,
				//     down: true,
				// },
				// {
				//     id: 5,
				//     key: "info.cnt_reviews",
				//     name: text.SORT_BY_REVIEWS_2,
				//     up: true,
				// },
			],
		};
	}

	onSort(sort) {
		const {
			location: { search },
			history,
		} = this.props;

		const getParams = queryString.parse(search);

		let urlArr = [];

		let activeSort = sort[0];

		if (!!activeSort.key) {
			getParams.sort = activeSort.key;
		} else {
			delete getParams.sort;
		}

		for (let key in getParams) {
			if (getParams[key]) {
				urlArr.push(`${key}=${getParams[key]}`);
			}
		}

		const providersUrl = generateUrl(Routes.Providers.route, {
			regionUrl: this.props.match.params.regionUrl,
			page: this.props.match.params.page,
		});

		history.push({
			pathname: providersUrl,
			search: urlArr.length ? `?${urlArr.join("&")}` : "",
		});
	}

	onFilter(filter) {
		const {
			match: { params },
			location: { search },
			history,
		} = this.props;
		const getParams = queryString.parse(search);
		let filterArr = [];
		let selectedProviders = [];
		let selectedServices = [];
		let selectedDody = [];

		if (filter.service) {
			filter.service.map((item) => {
				selectedServices.push(item.id);
			});
			getParams.service = selectedServices.join(",");
		}

		if (filter.providers) {
			filter.providers.map((item) => {
				selectedProviders.push(item.id);
			});
			getParams.providers = selectedProviders.join(",");
		}

		if (filter.dody) {
			filter.dody.map((item) => {
				selectedDody.push(item.id);
			});
			getParams.dody = selectedDody.join(",");
		}

		for (let key in getParams) {
			if (getParams[key]) {
				filterArr.push(`${key}=${getParams[key]}`);
			}
		}

		const providersUrl = generateUrl(Routes.Providers.route, {
			regionUrl: params.regionUrl,
		});

		history.push({
			pathname: providersUrl,
			search: filterArr.length && !filter.fullReset ? `?${filterArr.join("&")}` : "",
		});
	}

	onResetFilters() {
		this.onFilter({
			dody: [],
			service: [],
			providers: [],
			fullReset: true,
		});
	}

	render() {
		const {
			ApplicationModel: { text, ratesModel },
			aggregation: { providers, order_types, dody },
		} = this.props;

		order_types.sort(function (a, b) {
			return a.id - b.id;
		});

		let dodyModify = dody.map((item) => {
			return { id: item.global_id, name: item.name };
		});

		let orderTypesFinded = this.servicesReviewsInitFromGetParams(order_types);
		let providersFinded = this.providersInitFromGetParams(providers);

		let dodyFinded = this.dodyInitFromGetParams(dodyModify);

		let sortFinded = this.getSortFromParams(this.state.sort);

		let orientationChanger = (
			<OrientationChanger
				onChange={(flat) => ratesModel.setOrientation(flat)}
				flat={ratesModel.orientation}
			/>
		);

		let windowSizes = this.props.ApplicationModel.windowSizeModel.windowSizes;

		return (
			<React.Fragment>
				<FiltersLayout>
					<CollapseFiltersContainer
						resetFiltersHandler={() => this.onResetFilters()}
						showResetButtonAfterFilterApply
					>
						<FiltersItem>
							<SelectField
								multiselect={false}
								isFixedList={windowSizes.xs}
								windowSizes={windowSizes}
								items={order_types}
								onItemSelect={(items) =>
									this.onFilter({
										service: items,
									})
								}
								title={text.TYPE_OF_INTERNET}
								text={text}
								onlyInputDisabled={true}
								findItems={orderTypesFinded}
								placeholder={text.NO_MATTER}
								activePlaceHolder={text.CHOOSE_A_VALUE}
								datatest="providers_input_filter_internet_type"
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputName="select_internet_type"
							/>
						</FiltersItem>
						<FiltersItem>
							<SelectField
								multiselect={true}
								isFixedList={windowSizes.xs}
								windowSizes={windowSizes}
								items={providers}
								onItemSelect={(items) =>
									this.onFilter({
										providers: items,
									})
								}
								text={text}
								title={text.filtersProvider}
								findItems={providersFinded}
								activePlaceHolder={text.CHOOSE_A_PROVIDERS}
								datatest="providers_provider_input_filter"
								datatestApply="provider_filter_apply"
								whiteInput={true}
								height200={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputName="select_providers"
							/>
						</FiltersItem>
						<FiltersItem>
							<SelectField
								multiselect={false}
								isFixedList={windowSizes.xs}
								windowSizes={windowSizes}
								items={this.state.sort}
								onItemSelect={(items) => this.onSort(items)}
								title={text.sorting}
								text={text}
								onlyInputDisabled={true}
								findItems={sortFinded}
								placeholder={text.SORT_BY}
								activePlaceHolder={text.SORT_BY}
								withoutClose={true}
								datatest="providers_change_sort_providers"
								whiteInput={true}
								onFocus={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.setFocus();
								}}
								onBlur={() => {
									this.props.ApplicationModel.mobileFiltersTouchModel.removeFocus();
								}}
								inputName="sort_providers"
							/>
						</FiltersItem>
						{false && (
							<FiltersItem>
								<SelectField
									multiselect={true}
									items={dodyModify}
									windowSizes={windowSizes}
									isFixedList={windowSizes.xs}
									onItemSelect={(items) =>
										this.onFilter({
											dody: items,
										})
									}
									text={text}
									onlyInputDisabled={true}
									title={text.FILTERS_ADDITIONAL_SERVICES}
									findItems={dodyFinded}
									placeholder={text.ALL}
									activePlaceHolder={text.CHOOSE_A_SERVICES}
									datatest="providers_input_filter_sirvices"
									whiteInput={true}
								/>
							</FiltersItem>
						)}
					</CollapseFiltersContainer>
				</FiltersLayout>
			</React.Fragment>
		);
	}
}
